module.exports = __webpack_public_path__ + "static/media/yom.979a87ab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/yom.webp
// module id = 577
// module chunks = 0